import _objectWithoutProperties from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["monPR", "monDesignPR"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import { getDailyReportListApi, getDailyReportApi, getSendMailsApi } from '@/api';
import { dbDataHandle } from '@/store/function/common';
import { isDateAfterYesterday } from '@/utils/datetime';

import { DateTime } from 'luxon';
export default {
  name: 'EmailSend',
  data: function data() {
    return {
      isLoading: false,
      newEmailsValue: '',
      selectDailyReport: '',
      dailyReportArray: [],
      dailySiteArray: [],
      sendTime: DateTime.local().minus({
        days: 1
      }).setZone('Asia/Taipei').toFormat('yyyy-MM-dd'),
      sendmailArray: [],
      selectedPR: [],
      selectPROptions: ['設計 PR 資訊'],
      isEditable: false
    };
  },
  computed: {
    editableItems: function editableItems() {
      var _this$selectedPR;
      var additionalItems = (_this$selectedPR = this.selectedPR) !== null && _this$selectedPR !== void 0 && _this$selectedPR.length ? [{
        title: '設計 PR 值',
        key: 'monDesignPR',
        unit: '%'
      }, {
        title: '本月累積 PR 值',
        key: 'monPR',
        unit: '%'
      }] : [];
      return [
      // { title: '案場設置容量', key: 'capacity', unit: 'kWp' },
      {
        title: '今日發電量',
        key: 'acpAll',
        unit: 'kWh'
      }, {
        title: '今日累積日照量',
        key: 'IRR',
        unit: 'kWh/m²'
      }, {
        title: 'Specific Yield',
        key: 'peakWatt',
        unit: 'kWh/kWp'
      }, {
        title: '今日 PR',
        key: 'PR',
        unit: '%'
      }].concat(additionalItems);
    }
  },
  methods: {
    isDateAfterYesterday: isDateAfterYesterday,
    dbDataHandle: dbDataHandle,
    getDailyreportList: function getDailyreportList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _dailyreportlist$data;
        var dailyreportlist;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDailyReportListApi();
              case 2:
                dailyreportlist = _context.sent;
                if (dailyreportlist !== null && dailyreportlist !== void 0 && (_dailyreportlist$data = dailyreportlist.data) !== null && _dailyreportlist$data !== void 0 && _dailyreportlist$data.success) {
                  _this.dailyReportArray = dailyreportlist.data.data;
                  _this.selectDailyReport = dailyreportlist.data.data[0].group;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getDailyreport: function getDailyreport(factoryChange) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getDailyReport, data, _data$data, result, mails, preprocessDailyReportData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.dailyReportArray.find(function (x) {
                  return x.group === _this2.selectDailyReport;
                })) {
                  _context2.next = 9;
                  break;
                }
                _this2.isLoading = true;
                _this2.dailySiteArray = [];
                _context2.next = 5;
                return getDailyReportApi(_this2.selectDailyReport, _this2.sendTime);
              case 5:
                _yield$getDailyReport = _context2.sent;
                data = _yield$getDailyReport.data;
                if (data !== null && data !== void 0 && data.success) {
                  _data$data = data.data, result = _data$data.result, mails = _data$data.mails;
                  preprocessDailyReportData = result.map(function (obj) {
                    return {
                      factoryName: obj.factoryName,
                      reports: _objectSpread(_objectSpread({}, obj.reports), {}, {
                        monDesignPR: obj.reports.monDesignPR * 100,
                        // 為了顯示 %, 先 *100
                        monPR: obj.reports.monPR * 100
                      })
                    };
                  });
                  _this2.dailySiteArray = preprocessDailyReportData;
                  if (factoryChange) _this2.sendmailArray = mails;
                  _this2.selectedPR = [];
                }
                _this2.isLoading = false;
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    sendmail: function sendmail() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this3$sendmailArray, _sendmail$data;
        var sendData, group, date, reportData, mails, sendmail;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.dailyReportArray.find(function (x) {
                  return x.group === _this3.selectDailyReport;
                })) {
                  _context3.next = 3;
                  break;
                }
                _this3.$swal('請選擇群組');
                return _context3.abrupt("return");
              case 3:
                if ((_this3$sendmailArray = _this3.sendmailArray) !== null && _this3$sendmailArray !== void 0 && _this3$sendmailArray.length) {
                  _context3.next = 5;
                  break;
                }
                return _context3.abrupt("return", _this3.$swal('請新增收件人'));
              case 5:
                sendData = {
                  group: _this3.selectDailyReport,
                  date: _this3.sendTime,
                  reportData: _this3.dailySiteArray.map(function (obj) {
                    var _this3$selectedPR;
                    var _obj$reports = obj.reports,
                      monPR = _obj$reports.monPR,
                      monDesignPR = _obj$reports.monDesignPR,
                      reportsRest = _objectWithoutProperties(_obj$reports, _excluded);
                    var additionalItems = (_this3$selectedPR = _this3.selectedPR) !== null && _this3$selectedPR !== void 0 && _this3$selectedPR.length ? {
                      monDesignPR: monDesignPR / 100,
                      // 顯示資料*100 儲存資料除 100 回去
                      monPR: monPR / 100
                    } : {};
                    return {
                      factoryName: obj.factoryName,
                      reports: _objectSpread(_objectSpread({}, reportsRest), additionalItems)
                    };
                  }),
                  mails: _this3.sendmailArray
                };
                group = sendData.group, date = sendData.date, reportData = sendData.reportData, mails = sendData.mails;
                _context3.next = 9;
                return getSendMailsApi(group, date, reportData, mails);
              case 9:
                sendmail = _context3.sent;
                if (sendmail !== null && sendmail !== void 0 && (_sendmail$data = sendmail.data) !== null && _sendmail$data !== void 0 && _sendmail$data.success) {
                  _this3.$swal('寄送成功');
                }
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    emailPush: function emailPush() {
      if (this.newEmailsValue !== '' && this.newEmailsValue.indexOf('@') !== -1) {
        this.sendmailArray.push(this.newEmailsValue);
      } else {
        this.$swal('請填寫正確 emails 格式');
      }
    },
    emailSplice: function emailSplice(idx) {
      this.sendmailArray.splice(idx, 1);
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.getDailyreportList();
            case 2:
              _this4.getDailyreport(true);
            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};